import * as React from "react";
import { TbWindowMaximize, TbWindowMinimize, TbFileExport } from "react-icons/tb";
import { FiEdit2 } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import { ICompasAIChatAction } from "@/types/compass.types";

interface ActionItemActionsProps {
  action: ICompasAIChatAction; // retained for future use (e.g. conditional actions per action type)
  isExpanded: boolean;
  toggleExpansion: () => void;
  handleToggleEditing: () => void;
  handleDeleteAction: () => void;
  handleSaveToLibrary: () => void;
  currentStatus: string;
}

export const buildActionItemActions = (props: ActionItemActionsProps) => {
  const {
    isExpanded,
    toggleExpansion,
    handleToggleEditing,
    handleDeleteAction,
    handleSaveToLibrary,
    currentStatus,
  } = props;
  const isProcessing =
    currentStatus === "processing" || currentStatus === "queued" || currentStatus === "pending";
  const iconColor = currentStatus === "processing" ? "text-white" : "text-neutral-400";
  return [
    {
      id: "expand-toggle",
      icon: isExpanded ? (
        <TbWindowMinimize className={`size-3.5 ${iconColor}`} />
      ) : (
        <TbWindowMaximize className={`size-3.5 ${iconColor}`} />
      ),
      onClick: (e: React.MouseEvent) => {
        e.stopPropagation();
        toggleExpansion();
      },
      tooltipContent: isExpanded ? "Minimize" : "Maximize",
      disabled: false,
    },
    {
      id: "save",
      icon: <TbFileExport className={`size-3.5 ${iconColor}`} />,
      onClick: (e: React.MouseEvent) => {
        e.stopPropagation();
        handleSaveToLibrary();
      },
      tooltipContent: "Save to request library",
      disabled: isProcessing,
    },
    {
      id: "edit",
      icon: <FiEdit2 className={`size-3.5 ${iconColor}`} />,
      onClick: (e: React.MouseEvent) => {
        e.stopPropagation();
        handleToggleEditing();
      },
      tooltipContent: "Edit Action",
      disabled: isProcessing,
    },
    {
      id: "delete",
      icon: <FaRegTrashCan className="size-3.5 text-danger-200" />,
      onClick: (e: React.MouseEvent) => {
        e.stopPropagation();
        handleDeleteAction();
      },
      tooltipContent: "Remove action",
      disabled: isProcessing,
    },
  ];
};
